<template>
	<v-dialog v-model="isVisible" max-width="700">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Postulantes ya registrados:
			</p-header-dialog>
			<section class="tw-flex tw-flex-col tw-justify-between tw-gap-3 tw-p-6">
			<p :style="`color: ${$appColors.info}`">El archivo contiene postulantes con números de documento duplicados en comparación con los ya ingresados:</p>
			<ul class="tw-px-16" v-for="(list, index) in listError" :key="index">
				<li :style="`color: ${$appColors.info}`">{{ list }}</li>
			</ul>
			</section>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';

export default {
	name: 'add-subfactor-dialog',
	beforeCreate() {
	},
	created() {
	},
	mounted() {
	},
	data() {
		return {
			isVisible: false,
		};
	},
	components: { PHeaderDialog, CloseIcon, PCard },
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
	},
	computed: {
	},
	props: {
		listError: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
	},
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/list-errors-imports-dialog.vue